import { RouteChildrenProps } from "react-router";
import { EcapReportGroupEnum } from "../../../constants/constants";
import { ROUTE_PATHS } from "../../../constants/url-config";
import i18n from "../../../utils/i18n";
import { SettingIcon, StatisticIcon } from "../../atoms/icon";
import AppMainCard, { MainCardProp } from "../../atoms/main-card";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import "./ecap-module.scss";

const Main_Items: MainCardProp[] = [
  {
    index: 1,
    name: i18n.t("EcapModule.Pillar1Tile"),
    description: i18n.t("EcapModule.Pillar1Description"),
    icon: <StatisticIcon />,
    link: `${ROUTE_PATHS.ECAPReportGroup}?group=${EcapReportGroupEnum.Pillar1}`,
  },
  {
    index: 2,
    name: i18n.t("EcapModule.Pillar2Tile"),
    description: i18n.t("EcapModule.Pillar2Description"),
    icon: <StatisticIcon />,
    link: `${ROUTE_PATHS.ECAPReportGroup}?group=${EcapReportGroupEnum.Pillar2}`,
  },
  {
    index: 3,
    name: i18n.t("EcapModule.Dashboard"),
    description: i18n.t("EcapModule.DashboardDescription"),
    icon: <StatisticIcon />,
    link: ROUTE_PATHS.Dashboard,
  },
];

interface Props extends RouteChildrenProps {}

const EcapModule = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className="ecap-module-wrapper">
      <AppMainCard items={Main_Items} />
      <Button
        shape="round"
        type="default"
        className="setting-btn"
        onClick={() => props.history.push(ROUTE_PATHS.EcapLeaderOnboarding)}
      >
        <SettingIcon className="svg-icon" /> {t("ECAPLeader.btnConfiguration")}
      </Button>
    </div>
  );
};

export default EcapModule;
